"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const portal_types_1 = require("@/enums/portal-types");
const state_1 = __importDefault(require("./state"));
const getters = {
    router: () => state_1.default.router,
    isLoggedIn: () => state_1.default.isLoggedIn,
    userName: () => state_1.default.userName,
    questions() {
        if (!state_1.default.questions) {
            return [];
        }
        return state_1.default.questions;
    },
    countries: () => {
        if (!state_1.default.countries) {
            return [];
        }
        return state_1.default.countries;
    },
    question: (id) => {
        if (!state_1.default.questions || state_1.default.questions.length <= id)
            throw new Error();
        return state_1.default.questions[id];
    },
    preferredPortalUrl: () => {
        switch (state_1.default.preferredPortalType) {
            case (portal_types_1.PortalType.MASTERS):
                return 'mastersportal.com';
            case (portal_types_1.PortalType.BACHELORS):
                return 'bachelorsportal.com';
            case (portal_types_1.PortalType.PHD):
                return 'phdportal.com';
            case (portal_types_1.PortalType.SHORT_COURSES):
                return 'shortcoursesportal.com';
            case (portal_types_1.PortalType.DISTANCE_LEARNING):
                return 'distancelearningportal.com';
            case (portal_types_1.PortalType.PREPARATION_COURSES):
                return 'preparationcoursesportal.com';
            default:
                return 'mastersportal.com';
        }
    },
    portalSearchPath: () => {
        switch (state_1.default.preferredPortalType) {
            case (portal_types_1.PortalType.MASTERS):
                return 'mastersportal.com/search/master';
            case (portal_types_1.PortalType.BACHELORS):
                return 'bachelorsportal.com/search/bachelor';
            case (portal_types_1.PortalType.PHD):
                return 'phdportal.com/search/phd';
            case (portal_types_1.PortalType.SHORT_COURSES):
                return 'shortcoursesportal.com/search/course';
            case (portal_types_1.PortalType.DISTANCE_LEARNING):
                return 'distancelearningportal.com/search/distance-learning';
            default:
                return 'mastersportal.com';
        }
    },
    results: () => {
        return state_1.default.results;
    },
    portalType: () => {
        return state_1.default.portalType;
    }
};
exports.default = getters;
